import capitalOne from 'assets/sponsors/capitalOne.svg';
import IMC from 'assets/sponsors/IMC.svg';
import caterpillar from 'assets/sponsors/caterpillar.svg';
import optum from 'assets/sponsors/optum.svg';

import google from 'assets/sponsors/google.svg';
import grainger from 'assets/sponsors/grainger.svg';
import facebook from 'assets/sponsors/facebook.svg';
import checkbook from 'assets/sponsors/checkbook.svg';
import mirusResearch from 'assets/sponsors/mirusResearch.svg';
import collinsAerospace from 'assets/sponsors/collinsAerospace.svg';
import schlumberger from 'assets/sponsors/schlumberger.svg';
import johnDeere from 'assets/sponsors/johnDeere.png';
import citadel from 'assets/sponsors/citadel.svg';

import orchid from 'assets/sponsors/orchid.svg';
import bp from 'assets/sponsors/bp.svg';
import HRT from 'assets/sponsors/HRT.svg';
import abbvie from 'assets/sponsors/abbvie.svg';

export const BusSponsors = [
    capitalOne, IMC, caterpillar, optum,
];

export const CarSponsors = [
    google, grainger, facebook, checkbook,
    mirusResearch, collinsAerospace, schlumberger, johnDeere, citadel,
];

export const BikeSponsors = [
    orchid, bp, HRT, abbvie,
];
